import type { FreightClaim } from "@freightsimple/generated-dashboard-openapi-client/models/FreightClaim";

import { ViewShipmentsFreightClaimSectionRow } from "../CustomComponents/ViewShipmentsFreightClaimSectionRow";
import ShipmentSection from "@/Shared/Shipment/CustomComponents/ShipmentSection";
import type { DocumentsSectionItem } from "@/Shared/Shipment/CustomComponents/ShipmentDocumentsSectionGeneric";
import { Button } from "@freightsimple/ui-core/Controls/Button";

interface FreightClaimsSectionProps {
  documents: DocumentsSectionItem[];
  freightClaims: FreightClaim[];
}

export function ViewShipmentsFreightClaimsSection({
  documents,
  freightClaims,
}: FreightClaimsSectionProps) {
  const singleClaim = freightClaims.length === 1;

  if (freightClaims.length === 0) {
    return <></>;
  }

  return (
    <ShipmentSection
      title="Claims"
      subtitle={
        <>
          {singleClaim ? (
            <>Here is the claim attached to this shipment.</>
          ) : (
            <>Here are all the claims attached to this shipment.</>
          )}{" "}
          To learn more about the claim process, please visit our{" "}
          <Button
            size="link"
            inheritFont
            href="https://help.freightsimple.com/using-freightsimple/claims"
          >
            Help Center
          </Button>
        </>
      }
      id="claims-section"
    >
      {freightClaims.map((claim, index) => (
        <ViewShipmentsFreightClaimSectionRow
          key={claim.freightClaimId}
          freightClaim={claim}
          documents={documents}
          last={index === freightClaims.length - 1}
          disableReveal={singleClaim}
        />
      ))}
    </ShipmentSection>
  );
}
